import { useContext } from 'react';
import AuthenticatedContext from '../store/context';

export const useAuthenticated = (): any => {
    const [state, dispatch] = useContext(AuthenticatedContext);
    return [state, dispatch];
};
